<script>
import {mapGetters} from 'vuex'

export default {
  name: 'BackofficeActions',
  methods: {
    ...mapGetters(['getHotels', 'getHotelPeriods']),
    /**
     * Se l'hotel in configurazione ha abbinato un trasferimento obbligatorio
     * parto dal presupposto che ci sia un solo hotel nel preventivo
     * @param hotel
     * @returns {null|{codiceAndata: String, codiceRitorno: String}}
     */
    searchTrasferimentiCodiciFromHotel () {
      const hotelPeriodsReturned = this.getHotelPeriods()
      if (hotelPeriodsReturned && hotelPeriodsReturned.length === 1) {
        const hotel = hotelPeriodsReturned[0].selected[0].hotel
        const hotelBO = this.searchBackofficeHotel(hotel)
        if (hotelBO) {
          // hotelBO.codiceAndata = 'nyctrsfc' // for testing; da commentare
          // hotelBO.codiceRitorno = 'nyctrsfc' // for testing; da commentare
          const codiceAndata = hotelBO.codiceAndata ? hotelBO.codiceAndata.trim() : ''
          const codiceRitorno = hotelBO.codiceRitorno ? hotelBO.codiceRitorno.trim() : ''
          if (codiceAndata.length > 0) {
            return {codiceAndata, codiceRitorno}
          }
        }
      }
      return null
    },
    searchBackofficeHotel (hotel) {
      return this.searchBackofficeHotelFromLocationId(hotel.location.id)
    },
    searchBackofficeHotelFromLocationId (locationId) {
      return this.getHotels().list.find(hotel => {
        const codice = hotel.codice
        const fornitore = hotel.fornitore.name
        const {code, provider} = locationId
        return codice.trim() === code.trim() && fornitore === provider
      })
    },
    searchBackofficeHotelsTrasferimentiCodes () {
      const list = []
      this.getHotels().list.filter(item => item.isTrasferimentoObbligatorio).forEach(hotel => {
        list.push({code: hotel.codiceAndata, trasferimento: true})
        if (hotel.codiceAndata !== hotel.codiceRitorno) {
          list.push({code: hotel.codiceRitorno, trasferimento: true})
        }
      })
      return list
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/actions/BackofficeAction.vue